export const environment = {
  production: true,
  envName: 'staging',
  apiUrl: 'https://dev-api.salis.ae/api',
  sentryDsn:
    'https://8e2cabe0cf58d5f82d0a81b8d0d8e6e0@o4511852802080768.ingest.de.sentry.io/4511858350162000',
};
